<template>
  <v-app>
    <router-view />
  </v-app>
</template>

<script>
export default {
  name: 'App',
}
</script>

<style>
html, body {
  font-family: 'Noto Sans TC', sans-serif;
}
</style>
